import { Button } from '@/shared/ui/Button'
import { Card } from '@/shared/ui/Card'

type MissionShowEmptyProps = {
  onBack: () => void
}

export const MissionShowEmpty = ({ onBack }: MissionShowEmptyProps) => (
  <Card className="shadow-sm">
    <Card.Body className="flex flex-col items-center gap-3 p-8 text-center">
      <p className="m-0 text-sm font-bold text-gray-800">Missão não encontrada</p>
      <p className="m-0 text-sm text-gray-500">
        Este desafio não está disponível ou foi removido do evento.
      </p>
      <Button variant="secondary" size="sm" onClick={onBack}>
        Voltar para missões
      </Button>
    </Card.Body>
  </Card>
)
